import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faMapMarkerAlt, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import Header from './Component/Header';
import MenuFooter from './Component/MenuFooter';
import Construct from './images/Construct.png';
import Building from './images/Building1.png';
import QuickBuyimg2 from './images/QuickBuyimg2.png';
import { FullScreenLoader } from './Component/Loader';
import Arrowleft from './images/ArrowLeft.png';
import PhoneSpinner from './images/PhoneSpinner.png';

function Projects() {
    const navigate = useNavigate();
    const [userData, setUserData] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [customerProjects, setCustomerProjects] = useState([]);
    const [blocksData, setBlocksData] = useState([]);
    const [projectBlocksMap, setProjectBlocksMap] = useState({});
    const [customerData, setCustomerData] = useState(null);
const [showProjectMenu, setShowProjectMenu] = useState(null);
const [showLoader, setShowLoader] = useState(false);
const [showDeactivateConfirm, setShowDeactivateConfirm] = useState(false);
const [selectedProjectForDeactivate, setSelectedProjectForDeactivate] = useState(null);
const [isLoading, setIsLoading] = useState(false);
const [showPopup, setShowPopup] = useState(false);
const [popupMessage, setPopupMessage] = useState('');
const [popupType, setPopupType] = useState('');
const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
const [selectedProjectForDelete, setSelectedProjectForDelete] = useState(null);
const [pageLoading, setPageLoading] = useState(true);
const [shopNowLoading, setShopNowLoading] = useState(false);


    // First useEffect - load user data
    useEffect(() => {
        try {
            // Load user data from localStorage
            const storedData = localStorage.getItem('userData');
            if (storedData) {
                const parsedData = JSON.parse(storedData);
                console.log("Loaded user data:", parsedData);
                setUserData(parsedData);
            } else {
                // If no data in localStorage, try sessionStorage
                const sessionData = sessionStorage.getItem('userData');
                if (sessionData) {
                    const parsedData = JSON.parse(sessionData);
                    console.log("Loaded session data:", parsedData);
                    setUserData(parsedData);
                }
            }
        } catch (error) {
            console.error("Error loading user data:", error);
            setError("Failed to load user data");
        } finally {
            setLoading(false);
        }
    }, []);

    // Get customer details
    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem('userData'));
        if (userData?._id) {
            getCustomerDetails(userData._id);
        }
    }, []);

   
useEffect(() => {
    // Check for token and user data
    const token = sessionStorage.getItem('token');
    const userData = JSON.parse(sessionStorage.getItem('userData') || localStorage.getItem('userData') || '{}');
    
    if (!token || !userData._id) {
        console.log("No token or user data found, redirecting to consumer page");
        navigate('/consumer');
        return;
    }
}, [navigate]);


    // Fetch customer projects
    useEffect(() => {
        if (userData._id) {
            fetchCustomerProjects(userData._id);
        }
    }, [userData]);

     useEffect(() => {
      const timer = setTimeout(() => {
        setPageLoading(false);
      }, 1000);
    
      return () => clearTimeout(timer);
    }, []);
    
 

    const getCustomerDetails = async (customerId) => {
        setLoading(true);
        const userData = JSON.parse(localStorage.getItem('userData'));
        const token = userData?.token || sessionStorage.getItem('token');
        
        try {
            const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/get-customer-by-customerId?customer_id=${customerId}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'x-token': token
                }
            });
            
            const result = await response.json();
            
            if (result.success) {
                setCustomerData(result.data);
                console.log("Customer data fetched successfully:", result.data);
            } else {
                console.error('Failed to fetch customer:', result.message);
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchCustomerProjects = async (customer_id) => {
        try {
            setLoading(true);
            
            // Get the token and user data from session storage
            const token = sessionStorage.getItem('token');
            const userData = JSON.parse(sessionStorage.getItem('userData'));
            
            if (!token || !userData) {
                console.error("No token or user data found");
                navigate('/consumer');
                // setError('Authentication information not found. Please login again.');
                setLoading(false);
                return [];
            }
              
            if (!customer_id) {
                setLoading(false);
                return [];
            }
            
            console.log("Fetching projects for customer ID:", customer_id);
            
            // Call the API to get customer projects
            const apiUrl = `${process.env.REACT_APP_FORE_APILINK}/projects/get-projects-by-customer?customer_id=${customer_id}`;
            console.log("API URL:", apiUrl);
            
            const response = await fetch(apiUrl, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-token': token
                }
            });
            
            const data = await response.json();
            console.log("Customer projects response:", data);
            
            if (!response.ok) {
                throw new Error(data.error || data.message || 'Failed to fetch customer projects');
            }
            
            // Check if the response has the expected structure
            if (data.success && data.data) {
                console.log("Projects found:", data.data.length);
                setCustomerProjects(data.data); // Update state with fetched projects
                
                // Fetch blocks data for each project
                const blocksMap = {};
                for (const project of data.data) {
                    if (project._id) {
                        const blocksData = await fetchBlocksByProjectid(project._id);
                        blocksMap[project._id] = blocksData;
                    }
                }
                
                // Update the blocks map state
                setProjectBlocksMap(blocksMap);
            }
            
        } catch (error) {
            console.error('Error fetching customer projects:', error);
            setError(error.message || 'Failed to fetch customer projects');
        } finally {
            setLoading(false);
        }
    };

    const fetchBlocksByProjectid = async (_id) => {
        try {
            const token = await sessionStorage.getItem('token');
            
            const response = await fetch(`${process.env.REACT_APP_FORE_APILINK}/blocks/get-all-blocks-of-project?projectId=${_id}`, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'x-token': token
                },
            });
        
            const responseData = await response.json();
            console.log("API Response for project", _id, ":", responseData);
            
            // Check if the response has data property and it's an array
            if (responseData && responseData.data && Array.isArray(responseData.data)) {
                return responseData.data;
            } else if (responseData && Array.isArray(responseData)) {
                return responseData;
            } else {
                console.error('Unexpected response format:', responseData);
                return [];
            }
            
        } catch (error) {
            console.error('Failed to fetch blocks:', error);
            return [];
        }
    };

    const handleAddProject = () => {
       setShowLoader(true);
  setTimeout(() => {
    navigate('/consumer/addproject');
    setShowLoader(false);
  }, 1200);
};

    const navigateToProjectQuotes = (project) => {
        navigate("/consumer/app/home", { state: { project } });
    };

    const navigateToOrders = (project) => {
    navigate("/consumer/orders", { state: { project } });
};
    
    const openInGoogleMaps = (address) => {
        if (!address) return;
        
        // Format the address for Google Maps URL
        const formattedAddress = encodeURIComponent(address);
        const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${formattedAddress}`;
        
        // Open Google Maps in a new tab
        window.open(googleMapsUrl, '_blank');
    };


  const handleShopNow = () => {
    setShopNowLoading(true);
    
    setTimeout(() => {
        setShopNowLoading(false);
        navigate('/consumer/ProductDetails');
    }, 1000);
}


  const handleProjectClick = (project) => {
  setShowLoader(true);
  const projectBlocks = projectBlocksMap[project._id] || [];

  setTimeout(() => {
    navigate('/consumer/viewproject', {
      state: { 
        projectId: project._id,
        project: project,
        blocksData: projectBlocks
      }
    });
    setShowLoader(false); 
  }, 1200); 
};

const handleDeactivateClick = async (projectId, attempt = 1) => {
    setIsLoading(true);
    const RETRY_LIMIT = 3;
    
    try {
        const token = sessionStorage.getItem('token');
        const backendApiUrl = process.env.REACT_APP_FORE_APILINK;
        const ActivateURL = `${backendApiUrl}/admin/deactivate-project?projectId=${projectId}`;
        
        const response = await fetch(ActivateURL, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'x-token': token
            }
        });
        
        const data = await response.json();
        
        if (response.ok) {
            // Update the specific project's is_active status in the local state
            setCustomerProjects(prevProjects => 
                prevProjects.map(project => 
                    project._id === projectId 
                        ? { ...project, is_active: false }
                        : project
                )
            );
            
            setIsLoading(false);
            setPopupType('200or201');
            setPopupMessage('Project Deactivated Successfully');
            setShowPopup(true);
            setShowDeactivateConfirm(false);
            
            setTimeout(() => {
                setShowPopup(false);
            }, 3000);
        } else {
            setIsLoading(false);
            setPopupMessage(data.message);
            setPopupType(`${data.status}`);
            setShowPopup(true);
        }
    } catch (error) {
        console.error('Failed to fetch:', error);
        if (attempt < RETRY_LIMIT) {
            setTimeout(() => handleDeactivateClick(projectId, attempt + 1), 1000);
        } else {
            setIsLoading(false);
            setPopupMessage('Internal Server Error. Kindly Retry.');
            setPopupType('500');
            setShowPopup(true);
        }
    }
};



const handleDeactivateConfirm = (project) => {
    setSelectedProjectForDeactivate(project);
    setShowDeactivateConfirm(true);
    setShowProjectMenu(null); 
};

const handleDeleteClick = async (projectId, attempt = 1) => {
    setIsLoading(true);
    const RETRY_LIMIT = 3;
    
    try {
        const token = sessionStorage.getItem('token');
        const backendApiUrl = process.env.REACT_APP_FORE_APILINK;
        const deleteURL = `${backendApiUrl}/projects/delete-project?projectId=${projectId}`;
        
        const response = await fetch(deleteURL, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'x-token': token
            }
        });
        
        const data = await response.json();
        
        if (response.ok) {
            // Remove the deleted project from local state
            setCustomerProjects(prevProjects => 
                prevProjects.filter(project => project._id !== projectId)
            );
            
            setIsLoading(false);
            setPopupType('200or201');
            setPopupMessage('Project Deleted Successfully');
            setShowPopup(true);
            setShowDeleteConfirm(false);
            
            setTimeout(() => {
                setShowPopup(false);
            }, 3000);
        } else {
            setIsLoading(false);
            setPopupMessage(data.message || 'Failed to delete project');
            setPopupType(`${data.status || '400'}`);
            setShowPopup(true);
        }
    } catch (error) {
        console.error('Failed to delete project:', error);
        if (attempt < RETRY_LIMIT) {
            setTimeout(() => handleDeleteClick(projectId, attempt + 1), 1000);
        } else {
            setIsLoading(false);
            setPopupMessage('Internal Server Error. Kindly Retry.');
            setPopupType('500');
            setShowPopup(true);
        }
    }
};

const handleDeleteConfirm = (project) => {
    setSelectedProjectForDelete(project);
    setShowDeleteConfirm(true);
    setShowProjectMenu(null); 
};

    return (
        <div className="flex flex-col w-full min-h-screen bg-white">
               {loading && <FullScreenLoader text="Loading Projects..." />}
           <div className="w-full px-1 py-4 sticky top-0 z-10 border-b border-gray-200 bg-white">
            <div className="flex items-center">
              <img
                src={ Arrowleft} 
                className="w-10 h-6 text-gray-600 mr-2 cursor-pointer" 
                onClick={() => navigate(-1)}
              />
              <h1 className="text-[#000000] font-medium text-md">My Projects</h1>
            </div>
          </div>
          
            {/* Error message */}
            {error && (
                <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mx-4 my-4">
                    {error}
                </div>
            )}

            {/* My Projects section */}
            <div className="bg-gray-50 px-4 py-6 flex-1">

                {/* QuickBy Section */}
     <div className="mb-6">
  <div className="rounded-lg p-5 h-36 relative overflow-hidden" style={{ backgroundColor: 'rgba(241, 213, 213, 0.27)' }}>
    <div className="flex items-center justify-between h-full">
      {/* Left side content */}
      <div className="flex-1 flex flex-col justify-center pr-20">
        <h2 className="text-[#C20C0C] font-bold text-xl mb-2">QuickBuy</h2>
        <p className="text-[#000000] font-medium text-xs mb-4 leading-tight">
          Purchase building materials required for your project.
        </p>
        
           <button
          onClick={handleShopNow}
          disabled={shopNowLoading}
          className="bg-[#F43042] text-white px-4 py-1.5 mb-2 rounded-full text-xs font-medium hover:bg-red-700 transition duration-300 w-fit disabled:opacity-50 disabled:cursor-not-allowed"
      >
          {shopNowLoading ? (
              <div className="flex items-center justify-center">
                  <img
                      src={PhoneSpinner}
                      alt="Loading"
                      className="h-4 w-4 object-contain animate-spin mr-2"
                  />
                  Loading...
              </div>
          ) : (
              "Shop Now"
          )}
      </button>
      </div>
      
      {/* Right side image */}
      <div className="flex-shrink-0 mr-4 absolute right-0 bottom-0">
        <img
          src={QuickBuyimg2}
          alt="QuickBuy"
          className="h-32 w-auto object-contain"
        />
      </div>
    </div>
  </div>
</div>




              <div className="flex justify-end items-center mb-4">
  {customerProjects && customerProjects.length > 0 && (
    <button
      onClick={handleAddProject}
      className="flex items-center justify-center bg-white border border-gray-200 text-[#524D4D] py-1 px-3 rounded-lg hover:bg-gray-100 transition duration-300 text-sm"
    >
      Add Project
      <div className="ml-2 w-4 h-4 bg-white border border-gray-500 rounded-full flex items-center justify-center">
        <span className="text-gray-500 text-xs font-bold">+</span>
      </div>
    </button>
  )}
</div>



                
         <div className="flex flex-col">
  {customerProjects && customerProjects.length > 0 ? (
    // Display projects if available
    <div className="grid grid-cols-1 gap-3 mb-20 ">
      {customerProjects.map(project => (
        <div
          key={project._id}
          className={`bg-white rounded-lg overflow-hidden relative border border-[#E0D9D9] cursor-pointer ${
            !project.is_active ? 'opacity-50 grayscale' : ''
          }`}
          onClick={() => handleProjectClick(project)}
        >
          {/* Project Details with image on left */}
          <div className="p-2 mt-2">
            <div className="flex items-start">
              {/* Project Image - smaller and on the left */}
              <div className="mr-3 flex-shrink-0">
                {project.projectImage && project.projectImage.length > 0 ? (
                  <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-white">
                    <img
                      src={`${process.env.REACT_APP_FORE_MEASURIT_UIIMAGEURL}${project.projectImage[0]}`}
                      alt={project.projectName}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        console.error("Image failed to load:", e);
                        e.target.onerror = null;
                        e.target.src = Building; 
                      }}
                    />
                  </div>
                ) : (
                  <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-white flex items-center justify-center bg-gray-100">
                    <img src={Building} alt="Building" className="w-10 h-10 object-contain" />
                  </div>
                )}
              </div>
              
              {/* Project Name and Address */}
              <div className="flex-1">
                <div className="flex justify-between items-start">
                  <div className="pr-2 max-w-[65%]">
                    <h3 className="text-md font-semibold text-[#170101]">{project.projectName.toUpperCase()}</h3>
                    <p
                      className="text-[#170101] text-xs mt-0.5  font-semibold cursor-pointer hover:underline flex items-start"
                      title={project.siteAddress}
                      onClick={() => openInGoogleMaps(project.siteAddress)}
                    >
                      <span className="break-words">
                        {project.siteAddress
                          ? project.siteAddress.length > 24
                            ? project.siteAddress.substring(0, 24) + '...'
                            : project.siteAddress
                          : 'No address available'}
                      </span>
                    </p>
                  </div>
                  
                  {/* Blocks and Floors info - only display if data exists */}
                  {((projectBlocksMap[project._id] && projectBlocksMap[project._id].length > 0) ||  
                    project.numFloors || project.numBlocks) && (
                    <div className="flex flex-col space-y-1 flex-shrink-0">
                      {/* Display floors if data exists */}
                      {((projectBlocksMap[project._id] && projectBlocksMap[project._id].length > 0 &&
                         Math.max(...projectBlocksMap[project._id].map(block => block.numFloors || 0), 0) > 0) ||
                        project.numFloors > 0) && (
                        <div className="bg-[#E0D9D9] px-1 py-0.1 rounded-md text-center w-14">
                          <span className="text-[#000000] font-semibold text-[10px] whitespace-nowrap">
                            {projectBlocksMap[project._id] && projectBlocksMap[project._id].length > 0
                              ? Math.max(...projectBlocksMap[project._id].map(block => block.numFloors || 0), 0)
                              : project.numFloors || 0} {projectBlocksMap[project._id] && projectBlocksMap[project._id].length > 0 && Math.max(...projectBlocksMap[project._id].map(block => block.numFloors || 0), 0) === 1 ? 'Floor' : 'Floors'}
                          </span>
                        </div>
                      )}
                      
                      {/* Display flats if data exists */}
                      {((projectBlocksMap[project._id] && projectBlocksMap[project._id].length > 0 &&
                         projectBlocksMap[project._id].reduce((total, block) => total + (block.numFlats || 0), 0) > 0) ||
                        project.numBlocks > 0) && (
                     <div className="bg-[#E0D9D9] px-1  rounded-md text-center w-14">
                          <span className="text-[#000000] font-semibold text-[10px] whitespace-nowrap">
                            {projectBlocksMap[project._id] && projectBlocksMap[project._id].length > 0
                              ? projectBlocksMap[project._id].reduce((total, block) => total + (block.numFlats || 0), 0)
                              : project.numBlocks || 0} {projectBlocksMap[project._id] && projectBlocksMap[project._id].length > 0 && projectBlocksMap[project._id].reduce((total, block) => total + (block.numFlats || 0), 0) === 1 ? 'Flat' : 'Flats'}
                          </span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            
            {/* Full width border separator */}
            <div className="border-t border-[#E0D9D9] my-2 -mx-3 w-[calc(100%+1.5rem)]"></div>
            
            {/* Project Status */}
            <div className="mb-1">
              {/* Action Buttons - Split alignment */}
              <div className="flex justify-between items-center ml-2">
                {/* Three dots menu with red dots - Left side */}
                <button
                  className="w-6 h-6 rounded-full bg-white border border-gray-200 flex items-center justify-center transition-colors"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowProjectMenu(showProjectMenu === project._id ? null : project._id);
                  }}
                >
                  <span className="text-red-500 text-md leading-none font-bold">⋯</span>
                </button>
                
                {/* View buttons - Right side */}
                {project.quotationMeasurementStatus === "Pending" ? (
                <div className="flex flex-col items-start">
  <span className="text-[#1A73E7] text-xs font-medium">
    Measurements Survey
  </span>
  <span className="text-[#1A73E7] text-xs font-medium">
    Pending
  </span>
</div>

                ) : (
                  <div className="flex items-center space-x-2">
                    <button
                      className="border border-[#DE1B52] text-[#DE1B52] px-2 py-1 rounded-md text-xs font-medium hover:bg-red-50 transition-colors"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigateToProjectQuotes(project);
                      }}
                    >
                      View Quotes
                    </button>
                    <button
                      className="border border-[#DE1B52] text-[#DE1B52] px-2 py-1 rounded-md text-xs font-medium hover:bg-red-50 transition-colors"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigateToOrders(project);
                      }}
                    >
                      View Orders
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  ) : (
    // Display empty state
    <>
      <div className="text-left p-2">
        <h3 className="text-lg font-semibold text-[#000000] mb-4">Oops!</h3>
        <p className="text-gray-600 mb-6">Currently there are no projects in your account.</p>
      </div>
      <div className="flex justify-end mb-4">
        <img src={Construct} alt="Construction" className="h-32 object-contain" />
      </div>
     <button
        onClick={handleAddProject}
        className="flex items-center justify-center bg-[#EB001B] text-white py-2 px-4 rounded-md hover:bg-red-700 transition duration-300 shadow-sm -mt-28 ml-2"
        style={{ width: 'fit-content' }}
    >
        <FontAwesomeIcon icon={faPlusCircle} className="mr-2" />
        Add Project
    </button>
    </>
  )}
</div>

            </div>
{showProjectMenu && (
    <>
        {/* Backdrop */}
        <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40"
            onClick={() => setShowProjectMenu(null)}
        ></div>
        
        {/* Close Icon - Outside popup at top middle */}
        <button
            onClick={() => setShowProjectMenu(null)}
            className="fixed bottom-64 left-1/2 transform -translate-x-1/2 w-10 h-10 rounded-full bg-black flex items-center justify-center hover:bg-gray-800 transition-colors shadow-lg z-50"
        >
            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
        </button>
        
        {/* Bottom Popup - Blinkit Style */}
        <div className="fixed bottom-0 left-0 right-0 bg-gray-100 rounded-t-3xl shadow-2xl z-50 animate-slide-up">
            {/* Header without Cancel button */}
            <div className="px-6 py-4 rounded-t-3xl">
                <h3 className="text-xl font-semibold text-gray-900 text-center">Project Options</h3>
            </div>
                       
            {/* White Content Container */}
            <div className="bg-white mx-4 rounded-2xl mb-6 overflow-hidden">
                {/* Delete Project */}
<div 
    className="px-5 py-4 hover:bg-gray-50 cursor-pointer flex items-center justify-between border-b border-gray-100 transition-colors"
    onClick={() => handleDeleteConfirm(customerProjects.find(p => p._id === showProjectMenu))}
>                    <div className="flex items-center">
                        <div className="w-10 h-10 bg-gray-50 rounded-md flex items-center justify-center mr-4">
                            <svg className="w-5 h-5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                        </div>
                        <div>
                            <p className="text-base font-medium text-gray-900">Delete Project</p>
                            <p className="text-sm text-gray-500 mt-0.5">Permanently remove this project</p>
                        </div>
                    </div>
                    <svg className="w-5 h-5 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                </div>
                               
                {/* Deactivate Project */}
<div 
    className="px-5 py-4 hover:bg-gray-50 cursor-pointer flex items-center justify-between transition-colors"
    onClick={() => handleDeactivateConfirm(customerProjects.find(p => p._id === showProjectMenu))}
>                    <div className="flex items-center">
                        <div className="w-10 h-10 bg-gray-50 rounded-md flex items-center justify-center mr-4">
                            <svg className="w-5 h-5 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728L5.636 5.636m12.728 12.728L18.364 5.636M5.636 18.364l12.728-12.728" />
                            </svg>
                        </div>
                        <div>
                            <p className="text-base font-medium text-gray-900">Deactivate Project</p>
                            <p className="text-sm text-gray-500 mt-0.5">Temporarily disable notifications</p>
                        </div>
                    </div>
                    <svg className="w-5 h-5 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                </div>
            </div>
        </div>
    </>
)}

   


{/* Success/Error Popup - Improved Design */}
{showDeactivateConfirm && (
    <>
        <div className="fixed inset-0 bg-black bg-opacity-50 z-40"></div>
        <div className="fixed inset-0 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-sm mx-4 overflow-hidden">
                {/* Content Section */}
                <div className="px-6 py-6 text-center">
                    <h3 className="text-md font-medium text-gray-900 mb-4">
                        Are you sure you want to deactivate this project?
                    </h3>
                </div>
                
                {/* Buttons Section */}
                <div className="px-6 pb-6">
                    <div className="flex space-x-3">
                        <button
                            onClick={() => handleDeactivateClick(selectedProjectForDeactivate._id)}
                            className="flex-1 px-4 py-2 bg-[#D93025] text-white rounded-md font-medium hover:bg-orange-600 transition-colors disabled:opacity-50"
                            disabled={isLoading}
                        >
                            {isLoading ? 'Processing...' : 'Yes'}
                        </button>
                       
                        <button
                            onClick={() => setShowDeactivateConfirm(false)}
                            className="flex-1 px-4 py-2 bg-gray-100 text-gray-700 rounded-md font-medium hover:bg-gray-200 transition-colors"
                            disabled={isLoading}
                        >
                            No
                        </button>
                       
                    </div>
                </div>
            </div>
        </div>
    </>
)}



{/* Delete Confirmation Popup */}
{showDeleteConfirm && (
    <>
        <div className="fixed inset-0 bg-black bg-opacity-50 z-40"></div>
        <div className="fixed inset-0 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-sm mx-4 overflow-hidden">
                {/* Content Section */}
                <div className="px-6 py-6 text-center">
                    <h3 className="text-md font-medium text-[#000000] mb-4">
                        Are you sure you want to delete this project?
                    </h3>
                </div>
                
                {/* Buttons Section */}
                <div className="px-6 pb-6">
                    <div className="flex space-x-3">
                        <button
                            onClick={() => setShowDeleteConfirm(false)}
                            className="flex-1 px-4 py-2 bg-gray-100 text-gray-700 rounded-md font-medium hover:bg-gray-200 transition-colors"
                            disabled={isLoading}
                        >
                            No, Keep it
                        </button>
                        <button
                            onClick={() => handleDeleteClick(selectedProjectForDelete._id)}
                            className="flex-1 px-4 py-2 bg-red-500 text-white rounded-md font-medium hover:bg-red-600 transition-colors disabled:opacity-50"
                            disabled={isLoading}
                        >
                            {isLoading ? 'Deleting...' : 'Yes, Delete'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </>
)}



{pageLoading && (
            <div className="fixed inset-0 bg-white bg-opacity-80 backdrop-blur-sm z-50 flex items-center justify-center">
                <div className="text-center">
                    <img
                        src={PhoneSpinner}
                        alt="Loading"
                        className="h-16 w-16 object-contain animate-spin mx-auto mb-4"
                    />
                    <p className="text-gray-600 text-sm">Loading...</p>
                </div>
            </div>
        )}


            <MenuFooter />
        </div>
    );
}

export default Projects;
